import React from 'react'
import { Switch, Route } from 'react-router'

// Style
import '@assets/html/dist/css/style.css'

// Layouts
import {
  MainLayout,
  LoginLayout,
  ForgotPassword,
  ResetPassword
} from './layouts'

type Props = {}

const App: React.FC<Props> = () => (
  <Switch>
    <Route exact path="/login" component={LoginLayout} />
    <Route exact path="/forgot-password" component={ForgotPassword} />
    <Route exact path="/reset-password" component={ResetPassword} />
    <Route path="/" component={MainLayout} />
  </Switch>
)

export default App
